// Auth
export const SET_TOKEN = "Set Token";
export const SET_TEMP_ACCESS_TOKEN = "Set Temporary Token";

// Profile
export const FETCH_PROFILE_SUCCESS = "Fetch Profile Successful";
export const FETCH_PROFILE_FAILURE = "Fetch Profile Failed";
export const FETCH_AVATARS_SUCCESS = "Fetch Avatars Successful";
export const FETCH_AVATARS_FAILURE = "Fetch Avatars Failed";
export const SET_LOCATION = "Set Location";
export const SET_ADDRESS = "Set Address";
